export const _setSelectedMonth = (state, action) => {
  state.data.selectedMonth = action.payload;
};
